import * as Sentry from '@sentry/react';

const BUGSINK_DSN = process.env.REACT_APP_BUGSINK_DSN;
export function initSentry(): void {
    Sentry.init({
        dsn: BUGSINK_DSN,
        environment: process.env.NODE_ENV ?? 'production',

        // Capture 100 % of transactions for performance monitoring.
        // Lower this in production once baseline metrics are established.
        tracesSampleRate: 1.0,

        // Replay 10 % of regular sessions and 100 % of sessions with errors.
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,

        integrations: [
            Sentry.browserTracingIntegration(),
        ],
    });
}

export { Sentry };



